import * as pdfjsLib from "pdfjs-dist";

const generatePdfThumbnail = async (file: File): Promise<string | null> => {
  try {
    const fileData = await file.arrayBuffer(); // Convert the file to ArrayBuffer
    const pdf = await pdfjsLib.getDocument({ data: fileData }).promise; // Load the PDF document
    const firstPage = await pdf.getPage(1); // Get the first page

    const viewport = firstPage.getViewport({ scale: 1 }); // Define the viewport
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (!context) return null;

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    // Render the page into the canvas
    await firstPage.render({
      canvasContext: context,
      viewport,
    }).promise;

    // Convert the canvas to a data URL (thumbnail)
    const thumbnail = canvas.toDataURL("image/png");
    return thumbnail;
  } catch (error) {
    console.error("Error generating PDF thumbnail:", error);
    return null;
  }
};

export { generatePdfThumbnail };
